import React, { useContext, useEffect } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { OverviewContext } from "../../store/OverviewContext";
import { Navigate } from "react-router-dom";
import NotifyDialog from "../Dialogs/DoorsClosedNotifyMe";
import { TryBuyContext } from "./TryBuyContainer";

/**
 * PM5 T2 (money path, batch "onboarding") — converted from MUI v4 to MUI v5+
 * (`@mui/material`). See docs/mui-conversion-guide.md.
 *
 * Import swap only: this file has no `makeStyles`, and the Backdrop's inline
 * `style` is untouched (inline styles are engine-agnostic). The `NotifyDialog`
 * it renders converted in T1.
 */

function TryBuyModal({ type }: { type: "notify" | "trial" }) {
  const overviewContext = useContext(OverviewContext);
  const { setDialogOpen } = useContext(TryBuyContext);

  const doorsOpen = !!overviewContext.overview?.doors?.trialsOpen;
  useEffect(() => {
    if (doorsOpen) {
      setDialogOpen(false);
    }
  }, [doorsOpen, setDialogOpen]);

  if (
    !overviewContext.overview ||
    overviewContext.error ||
    overviewContext.loading
  ) {
    return (
      <Backdrop open style={{ zIndex: 1000000, color: "#fff" }}>
        <CircularProgress color="primary" />
      </Backdrop>
    );
  }

  if (!doorsOpen)
    return (
      <NotifyDialog open type={type} closed={() => setDialogOpen(false)} />
    );

  return <Navigate to="/try" replace />;
}

export default TryBuyModal;
